export const Popup = {
  Fine: "00",
  SelfCertification: "01",
  Reject: "02",
};

export const SelfCertificationType = {
  Residence: 1,
  Property: 2,
  TSD600: 3,
};

/** Key used in messageOverrides for each SelfCertificationType (1=residence, 2=property, 3=tsd600) */
export const SELF_CERT_TYPE_KEY = {
  [SelfCertificationType.Residence]: "residence",
  [SelfCertificationType.Property]: "property",
  [SelfCertificationType.TSD600]: "tsd600",
};

/** Default message IDs per cert type; used when no messageOverrides provided. See MESSAGE_OVERRIDES.md */
export const DEFAULT_MESSAGE_IDS = {
  titleSelfCert: {
    residence: "non-face-crs.title",
    property: "non-face-crs.title.3",
    tsd600: "non-face-crs.title.tsd600",
  },
  titleRejectCert: {
    residence: "non-face-crs.title.2",
    property: "non-face-crs.title.3",
    tsd600: "non-face-crs.title.tsd600",
  },
  messageSelfCert: {
    residence: {
      0: "non-face-crs.message.1",
      1: "non-face-crs.message.2",
      2: "non-face-crs.message.3",
    },
    property: {
      0: null,
      1: "non-face-crs.message.2",
      2: "non-face-crs.message.3",
    },
    tsd600: {
      0: "non-face-crs.message.tsd600.1",
      1: "non-face-crs.message.tsd600.2",
      2: "non-face-crs.message.3",
    },
  },
  messageRejectCert: {
    residence: "non-face-crs.message.reject-message",
    property: "non-face-crs.message.reject-message.2",
    tsd600: "non-face-crs.message.reject-message.tsd600",
  },
};
